const translation = {
  WelcomeBack: 'Welcome Back',
  LoginToContinue: 'Login to continue',
  Login: 'Login',
  EnterpriseResourcePlanning: 'Enterprise Resource Planning',
  LoggingIn: 'Logging in...',
  ForgotPassword: 'Forgot Password?',
  NeatixErp: 'Neatix ERP',
  AllRightsReserved: 'All rights reserved.',
  EnterUsername: 'Enter username',
  EnterPassword: 'Enter password',

  LoginSuccess: 'Login successful! Redirecting...',
  LoginError: 'Invalid username or password',
  ServerError: 'Server error, please try again later',
  NetworkError: 'Network error, please check your connection',
  Basic_salary: 'Basic salary',
  Dashboard: 'Dashboard',
  Edit_Aassignment: 'Edit Aassignment',
  Arabic: 'Arabic',
  English: 'English',
  Turkish: 'Turkish',
  Change: 'Change',
  HomePage: 'Home Page',
  SystemLanguage: 'System language',
  ChooseLanguage: 'Choose Language',
  Language: 'language',
  UpdateData: 'Update Data',
  UpdateAttendanceData: 'Update Attendance Data',
  DataUpdatedSuccessfully: 'Data Updated Successfully',
  AttendanceDetails: 'Attendance Details',
  AttendanceIndicators: 'Attendance Indicators',
  Imprint: 'Imprint',
  Delay: 'Delay',

  Profile: 'Profile',
  logout: 'logout',
  ChangePassword: 'Change Password',
  CurrentPassword: 'Current Password',
  NewPassword: 'New Password',
  ConfirmNewPassword: 'Confirm New Password',
  EnterCurrentPassword: 'Enter Current Password',
  EnterNewPassword: 'Enter New Password',

  ContainsMoreThan_8_Characters: 'Contains more than 8 characters',
  ContainsSpecialCharacters: 'Contains special characters',
  ContainAtLeastOneNumber: 'Contain at least one number',
  ContainAtLeastOneCapitalLetter: 'Contain at least one capital letter',
  MatchThePassword: 'Match the password',

  Yes: 'Yes',
  No: 'No',
  Confirmation: 'Confirmation',
  MsgConfirm: 'Are you sure about the deletion process ?',

  CREATED: 'CREATED',
  QUESTION: 'QUESTION',
  ANSWER: 'ANSWER',
  TRANSFER: 'TRANSFER',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',

  Duration: 'Duration',

  DaysAbsence: 'Days Absence',
  ABSENT: 'ABSENT',
  LATE: 'LATE',
  EARLY: 'EARLY',
  FingerprintData: 'Fingerprint Data',

  Back: 'Back',
  Record: 'Record',
  GeneralSystemLists: 'General System Lists',
  Image: 'Image',
  Welcome: 'Welcome',
  AddNewEmployee: 'Add New Employee',
  EmployeeNumber: 'Employee Number',
  title: 'title',
  LocalName: 'Local Name',
  GlobalName: 'Global Name',
  EmployeeName: 'Employee Name',
  Identity: 'Identity',
  'Marital Status': 'Marital Status',

  SaveSuccess: 'Data saved successfully',
  SaveError: 'Error occurred while saving',
  RedirectingMessage: 'Redirecting to employees list...',
  UnsavedChangesWarning: 'You have unsaved changes. Do you want to leave without saving?',
  UnsavedChangesAlert: 'You have unsaved changes',
  LoadingEmployeeData: 'Loading employee data...',
  LoadError: 'Error loading data',
  SaveChanges: 'Save Changes',
  ResetForm: 'Reset Form',
  RequiredFieldsNote: 'Fields marked with (*) are required',
  PersonalInformation: 'Personal Information',
  AdditionalPersonalInfo: 'Additional Personal Info',
  FinancialInformation: 'Financial Information',
  ProfilePicture: 'Profile Picture',
  QuickTips: 'Quick Tips',
  SaveOftenTip: 'Save your changes frequently',
  VerifyDataTip: 'Verify data before saving',
  Age: 'Age',
  Years: 'years',
  IBANFormatWarning: 'IBAN should start with SA prefix',
  Optional: 'Optional',
  ExtraInfoSaveError: 'Error saving extra information',
  // Image messages
  ImageSizeError: 'Image size should not exceed 5MB',
  ImageTypeError: 'Please select an image in JPEG, PNG, or JPG format',
  ImageRequirements: 'Max size: 1MB, Allowed formats: JPG, PNG, JPEG',
  RemoveImage: 'Remove Image',
  NoImageSelected: 'No image selected',
  EmployeeNumberHelp: 'Employee number cannot be modified',
  AbsenceAddedSuccessfully: 'Absence record added successfully',

  endDateAfterStart: 'End date must be after start date',
  Absencehistory: 'Absence History',
  AddAbsence: 'Add Absence',
  NoAbsenceRecords: 'No absence records found',
  viewDetails: 'View Details',
  pending: 'Pending',

  AbsenceDetails: 'Absence Details',
  NoNotes: 'No notes',

  Gender: 'Gender',
  DateofBirth: 'Date of Birth',
  HiringDate: 'Hiring Date',
  BirthCountry: 'Birth Country',
  CityOfbirth: 'City Of birth',
  Nationality: 'Nationality',
  AnnualLeave: 'Annual Leave',
  Required: 'Required',
  Employees: 'Employees',
  Home: 'Home',
  Search: 'Search',
  EmployeeFilter: 'Employee Filter',
  EmployeeStatus: 'Employee Status',
  'On-the-job': 'On-the-job',
  Terminated: 'Terminated',
  NotAssigned: 'Not assigned',
  ServiceStartDate: 'Service Start Date',
  ServiceEndDate: 'Service End Date',
  TotalYears: 'Total Years',
  TotalMonths: 'Total Months',
  TotalDays: 'Total Days',
  ApprovalDate: 'Approval Date',
  ProcedureCompletionDate: 'Procedure Completion Date',
  NoticeDate: 'Notice Date',
  TerminationOfService: 'TerminationOfService',
  Delegations: 'Delegations',
  DelegateFor: 'Delegate For',
  DelegateFrom: 'Delegate From',
  Delegate: 'Delegate',

  TotalEmployees: 'Total employees',
  EmployeesOnTheJob: 'Employees on the job',
  EmployeesServicesHaveEnded: 'Employees whose services have ended',
  EmployeesOnLeave: 'Employees on leave',

  EmployeesByDepartment: 'Employees by Department',
  EmployeesByNationality: 'Employees by Nationality',

  EmployeeDetails: 'Employee Details',
  Assign: 'Assign',
  EndOfService: 'End of Service',
  Department: 'Department',
  Previous: 'Previous',
  Next: 'Next',
  Save: 'Save',
  Clear: 'Clear',
  Cancel: 'Cancel',
  Exit: 'Exit',
  Showing: 'Showing',
  to: 'to',
  of: 'of',
  entries: 'entries',

  EntriesVisible: 'Entries visible',
  OfTotal: 'of total',

  EditDepartment: 'Edit Department',
  BasicInformation: 'Basic information',
  EmployeePhoto: 'Employee photo',

  ViewDetails: 'View Details',
  group: 'group',
  Grade: 'Grade',
  Job: 'Job',
  Position: 'Position',
  Vacancy: 'Vacancy',
  location: 'Location',
  SuperVisor: 'Super Visor',
  Payroll: 'Payroll',
  QuickPay: 'Quick Pay',
  Status: 'Status',
  'Start Date': 'Start Date',
  'Employee Aassignment': 'Employee Aassignment',
  CurrentAssignment: 'Current Assignment',

  NewAssignments: 'NewAssignments',

  Date_from: 'Date From',
  End_Date: 'To Date',

  Sub_Lists: 'Sub Lists',

  FieldType: 'Field Type',
  DefaultValue: 'Default Value',
  All: 'All',
  Partial: 'Partial',
  _Quick: 'Quick Pay',

  Flexible: 'Flexible',

  navigation: 'Navigation',
  dashboard: 'Dashboard',
  selfService: 'Self Service',
  employees: 'Employees',
  employee: 'employee',
  Employee: 'Employee',
  Organizations: 'Organizations',
  Organization: 'Organization',
  OperationUnit: 'Operation Unit',
  OperationUnits: 'Operation Units',
  List_Organizations: 'Organizations',
  OrganizationalUnits: 'Organizational Units',
  NewOrganizationalUnit: 'New Organizational Unit',

  payroll: 'Payroll',
  hrSettings: 'HR Settings',
  attendancePlan: 'Attendance Plan',
  systemManagement: 'System Management',
  approvals: 'Approvals',
  users: 'Users',
  login: 'Login',
  ResetPassword: 'Reset Password',

  sessionStatus: 'Session Status',
  expiresIn: 'Expires in',
  sessionExpired: 'Session Expired',
  sessionExpiredCountdown: 'Session Expired<br>({{countdown}} seconds)',
  sessionExpiredMessage: 'Your session has expired. Would you like to refresh your login data or log out?',
  refreshLogin: 'Refresh Login',
  logOut: 'Log Out',
  success: 'Success!',
  loginRefreshSuccess: 'Login data refreshed successfully. You can continue using the system.',
  errorOccurred: 'Sorry, an error occurred',
  loginRefreshError: 'Unable to refresh login data. You will be logged out automatically for security.',
  refreshingLogin: 'Refreshing login data...',
  pleaseWait: 'Please wait a moment.',

  Permissions: 'Permissions',
  ApplicationPermissions: 'Application Permissions',
  UserPermissions: 'User Permissions',
  ExtraPermissions: 'Extra Permissions',
  RulesPermissions: 'Rules Permissions',

  UserRules: 'User Rules',
  AddUserRules: 'Add User Rules',
  EditUserRules: 'Edit User Rules',
  isActive: 'Active',
  InActive: 'InActive',
  NotAvailable: 'Not available',

  Authorising_Person: 'Authorising Person',
  Absence: 'Absence',
  Absence_Type: 'Absence Type ',
  Date_TO: 'End Date',
  Days: 'Days',
  replacement: 'replacement',
  Notes: 'Notes',
  'Leave Request': 'Leave Request',
  TypeOfRequest: 'Type Of Request',
  DateOfRequest: 'Date of Request',
  Applicant: 'Applicant',
  RequestDetails: 'Request Details',
  RequestAction: 'Request Action',
  NumberOfRequest: 'Number of Request',
  RequestForms: 'Request Forms',
  SelfServiceForms: 'Self Service Forms',

  ViewRequest: 'View Request',
  RequestRules: 'Request Rules',
  FollowRequests: 'Follow Requests',
  RequestsTracking: 'Requests Tracking',
  RuleConditions: 'Rule Conditions',
  NotificationSettings: 'Notification Settings',
  MessageText: 'MessageText',
  HintMessageText: 'Type @ for the appearance of available variables',
  HintMessageText1:
    "When you type ' @ ' in the text, you will be shown which columns have been selected to include in the notification message.",

  TypeNotification: 'Type Of Notification',
  SystemNotification: 'System Notification',
  smsMessage: 'sms Message',
  WhatsAppMessage: 'WhatsApp Message',
  AutomaticUser: 'Automatic User',
  AutomaticMail: 'Automatic Mail',
  AutomaticNumber: 'Automatic Number',
  TypeData: 'TypeData',

  NotificationsManagement: 'Notifications Management',
  NotificationStatus: 'Notification Status',
  NotificationIcon: 'Notification Icon',
  NotificationName: 'Notification Name',
  NewNotification: 'New Notification',
  EditNotification: 'Edit Notification',
  NoticNessage1: 'Are you sure that this notification has been deactivated',
  NoticNessage2: 'Are you sure to activate this notification',
  ActiveNotification: 'Active Notification',
  TurnOffNotification: 'Turn off Notification',

  TimeSettings: 'Time Settings',
  SendSettings: 'Send Settings',
  Columns: 'Columns',
  Variants: 'Variants',
  NotificationVariables: 'Notification Variables',
  NotificationInformation: 'Notification Information',

  PENDING: 'Pending',
  WAITING: 'Waiting for action',
  WAITING_NOTF: 'Waiting for Notification',
  NOTIFIED: 'Notified',
  INPROGRESS: 'In Progress',
  Delegated: 'Delegated',

  Table: 'Table',

  ThereAreNoReportsToDisplay: 'There are no reports to display',
  ViewReport: 'View Report',
  Reports_Management: ' Reports Management',
  Reports: 'Reports',
  Report: 'Report',
  Add_Reports: 'Add Reports',
  Edit_Reports: 'Edit Reports ',
  Reports_Name: 'Reports Name',
  Report_information: 'Report information',
  Report_variants: 'Report variants',
  Report_columns: 'Report columns',
  Static_Value: 'Static Value',
  Parameter_Name: 'Parameter Name',
  Parameter_Value: 'Parameter Value',
  Vasible: 'Vasible',
  Application: 'Application',
  Layout: 'Layout',
  Parameter_Type: 'Parameter Type',
  Data_Source: 'Data Source',
  Alias_Name: 'Alias Name',
  Column: 'Column',
  NoData: 'No data to display',

  Function: 'Function',
  Add_Chart_For_Report: 'Add Chart For Report',
  Edit_Chart_For_Report: 'Edit Chart For Report',
  Current_Charts: 'Current Charts',
  Charts_Report: 'Charts Report',
  Indicators: 'Indicators',
  Shape: 'Shape',
  Kpi_Name: 'Kpi Name ',
  Format_Date: 'Format Date',

  DashboardManagement: 'Dashboard Management',
  AddNewDashboard: 'Add New Dashboard',
  EditDashboard: 'Edit Dashboard',
  ManagingPrintingTemplates: 'Managing Printing Templates',
  PrintingTemplates: 'Printing Templates',
  LetterManagement: 'Letters Management',
  AddNewLetter: 'Add New Letter',
  TemplateConstructionExplanations: 'Template Construction Explanations',
  TemplateName: 'Template Name',
  TemplateType: 'Template Type',
  ReportTemplate: 'Report Template',
  TemplateInformation: 'Template Information',
  TemplateVariants: 'Template Variants',
  TemplateColumns: 'Template Columns',
  AddNewTemplates: 'Add New Templates',
  EditTemplates: 'Edit Templates',
  'Add&EditLetterTemplate': 'Add and edit letter template',
  TemplateSettings: 'Template Settings',

  field: 'Field',
  FieldName: 'Field Name',
  QR: 'QR Code',
  RepetitionLinesInTable: 'Repetition of lines in the table',

  Height: 'Height',
  Width: 'Width',

  GeneralLists: 'General Lists',
  Contracts: 'Contracts',
  RealEstateContracts: 'RealEstate Contracts',
  Add_Contract: 'Add Contract',
  Edit_Contract: 'ُEdit Contract',
  RealEstate: 'Real Estate',
  Update_Real_Estate: 'Update Real Estate',
  Add_Real_Estate: 'Add Real Estate',

  Distance: 'Distance',
  Accomodation: 'Accomodation',

  Type: 'Type',
  Type_Real_Estate: 'Type Real Estate',
  Types_Real_Estate: 'Types Real Estate',
  Annual_Rent: 'Annual Rent',
  Water_Meter: 'Water Meter',
  Gas_Counter: 'Gas Counter',
  Electricity_Meter: 'Electricity Meter',
  Attitudes_Meter: 'Attitudes Meter',
  Capacity: 'Capacity',
  LandArea: 'Land Area',

  Active: 'Active',

  InstallmentValue: 'Installment Value',
  VAT_Percentage: 'VAT Percentage',
  VAT_Value: 'VAT Value',
  TypeInstallment: 'TypeInstallment',
  AddInstallment: 'Add Installment',
  InstallmentsGeneration: 'Installments Generation',

  Branches: 'Branches',
  Branche: 'Branche',
  AddBranche: 'Add Branche',
  EditBranche: 'Edit Branche',

  Workshops: 'Workshops',
  AddWorkshop: 'Add Workshop',
  EditWorkshop: 'Edit Workshop',

  Time: 'Time',

  EndTime: 'End Time',
  StartTime: 'Start Time',

  LastMaintenanceDate: 'Last Maintenance Date',
  Purchase_Price: 'Purchase Price',
  dateOfExpiry: 'date Of Expiry',
  ServiceDate: 'ServiceDate',
  Barcode: 'Barcode',
  Code: 'Code',
  AssetNumber: 'Asset Number',
  Engine_Status: 'Engine Status',
  Chassis_Number: 'Chassis Number',
  Serial_Number: 'Serial Number',
  Plate_Number: 'Plate Number',
  Image_of_Equipment: 'Image of Equipment',
  Assets_and_Equipment: 'Assets and Equipment',
  AddEquipment: 'Add Equipment',
  AddVehicle: 'Add Vehicle',
  Odometer: 'Odometer',
  AssignDriver: 'Assign Driver',
  Update_Odometer: 'Update Odometer',
  Drivers: 'Drivers',

  DriverType: 'Driver Type',
  EmployeeDriver: 'Employee Driver',
  ExternalDriver: 'External Driver',
  EmployeeNameDisplay: 'Employee Name',

  EquipmentAndVehicles: 'Equipment and Vehicles',
  HandOver_TakeOver: 'HandOver / TakeOver',

  takeoverForm: 'Takeover Form',
  handoverDetails: 'Handover Details',
  Vehicles: 'Vehicles',
  Handover: 'Handover',
  Takeover: 'Takeover',
  MaintenanceTeam: 'Maintenance Team',
  SpareParts: 'Spare Parts',
  noTeamMembers: 'No members in the maintenance team',
  noPartsAdded: 'No spare parts added',

  itemName: 'Item Name',
  unit: 'Unit',
  quantity: 'Quantity',
  price: 'Price',
  total: 'Total',
  description: 'Description',
  select: 'Select',

  AddDrivers: 'Add Drivers',
  EditDrivers: 'Edit Drivers',
  Suppliers: 'Suppliers',
  supplier: 'Supplier',
  Supplier: 'Supplier',
  AddSuppliers: 'Add Suppliers',
  EditSuppliers: 'Edit Suppliers',
  DriverName: "Driver's name",
  Owners: 'Owners',
  Journeys: 'Journeys',
  TypeMaintenance: 'Type Of Maintenance',
  MaintenanceOrders: 'Maintenance Orders',
  MaintenanceRequests: 'Maintenance Requests',
  RequestTitle: 'Request Title',
  EquipmentName: 'Equipment Name',

  InspectionTypes: 'Inspection Types',
  InspectionItemsReceiveAndDelivery: 'Inspection Items (Receive & Delivery)',

  InspectionItems: 'Inspection Items',
  AddInspectionItems: 'Add Inspection Items',
  EditInspectionItems: 'Edit Inspection Items',
  EquipmentInspection: 'Equipment Inspection',
  InspectionLevel: 'Inspection Level',
  EditInspection: 'Edit Inspection',
  PreviousInspections: 'Previous Inspections',
  NewScan: 'New Scan',
  InspectionDate: 'Inspection Date',
  Item: 'Item',
  AllItemsRequired: 'All items are required',

  DragFilesHere: 'Drag files here or',
  ChooseFiles: 'choose files',

  VehicleLogs: 'Vehicle History',

  VehicleInfo: 'Vehicle Information',
  Vehicle: 'Vehicle',
  DeliveryDate: 'Delivery Date',
  ReceiptDate: 'Receipt Date',
  HandoverDate: 'Handover date',
  TakeoverDate: 'Takeover date',

  statusAndEndDate: 'Status & Closing Date',
  NewMaintenanceOrder: 'New Maintenance Order',
  DirectMaintenanceOrder: 'Direct Maintenance Order',
  MaintenanceOrderFromRequest: 'Maintenance Order From Request',
  inventoryStatus: 'inventory Status',
  isConfrimStatus: 'Confrim Status',
  Open: 'Open',
  Closed: 'Closed',

  InspectionList: 'Inspection List',
  VehicleDiagram: 'Vehicle Diagram',
  Attachments: 'Attachments',
  AddYourNotesHere: 'Add your notes here',
  Saving: 'Saving',

  Mode: 'Mode',
  Draw: 'Draw',
  Comment: 'Comment',
  DrawingMode: 'Drawing Mode',
  CommentingMode: 'Commenting Mode',
  MarkerType: 'Marker Type',
  Circle: 'Circle',
  Square: 'Square',
  Line: 'Line',
  Ring: 'Ring',
  MarkerColor: 'Marker Color',
  Red: 'Red',
  Blue: 'Blue',
  Green: 'Green',
  Yellow: 'Yellow',
  Purple: 'Purple',
  MarkerSize: 'Marker Size',
  CommentLabel: 'Comment',
  ShowPredefinedComments: 'Show Predefined Comments',
  PredefinedComments: 'Predefined Comments',
  DeleteMarker: 'Delete Marker',
  DamageDescriptionPlaceholder: 'Enter a description of the damage...',
  Undo: 'Undo',
  ClearAll: 'Clear All',
  SaveSuccessMessage: 'Damage locations and comments saved successfully!',
  ClearConfirmation: 'Are you sure you want to clear all markers?',
  DrawingInstruction: 'Click on the image to add a marker at the damage location',
  CommentingInstruction: 'Click on an existing marker to add a comment',
  ShowMore: 'Show More',
  HideHelp: 'Hide Help',
  HelpDrawInstruction: 'In drawing mode: Click to add a marker',
  HelpCommentInstruction: 'In commenting mode: Click on a marker to select it',
  HelpDragInstruction: 'Drag markers to adjust their position',
  Scratch: 'Scratch',
  Dent: 'Dent',
  Break: 'Break',
  Rust: 'Rust',
  Corrosion: 'Corrosion',
  Crack: 'Crack',
  ColorDamage: 'Color Damage',

  DescriptionAR: 'Description AR',
  DescriptionEN: 'Description EN',
  Descriptions: 'Descriptions',

  Residential: 'Residential',
  BusinessLocation: 'Business Location',
  BookingSeats: 'Booking Seats',

  AddOwners: 'Add Owners',
  EditOwners: 'Edit Owners',
  Manufacturers: 'Manufacturers',
  Manufacturer: 'Manufacturer',
  AddManufacturers: 'Add Manufacturers',
  EditManufacturers: 'Edit Manufacturers',
  Model: 'Model',
  AddModel: 'Add Model',
  EditModel: 'Edit Model',
  WorkRequests: 'Work Requests',
  AddWorkRequests: 'Add Work Requests',
  DateOfReading: 'Date Of Reading',
  OrderNumber: 'Order Number',

  SAR: 'SAR',
  WorkshopNotLinked: 'Selected workshop is not linked to inventory, cannot add spare parts',
  OrderTypeSelection: 'Select Maintenance Order Type',
  OrderTypeDescription:
    'Please specify if the maintenance order is internal or external and select the appropriate workshop/supplier',
  OrderType: 'Order Type',
  ConfirmSelection: 'Confirm',

  Equipment: 'Equipment',
  Workshop: 'Workshop',
  Expected_start_date: 'Expected Start Date',
  Expected_end_date: 'Expected End Date',
  Material_price: 'Items Cost',
  Remuneration_Workers: 'Assets Cost',
  Other_amounts: 'Other Cost',
  Total: 'Total',
  RequestNumber: 'Request Number',
  RequestDescription: 'Request Description',
  RequestType: 'Request Type',
  RequestDate: 'Request Date',
  Priority: 'Priority',
  Source: 'Source',
  Branch: 'Branch',

  Close_Maintenance_Order: 'Close Maintenance Order',
  MaintenanceOrder: 'Maintenance Order',
  CreateMaintenanceOrder: 'Create Maintenance Order',
  AddMaintenanceOrder: 'Add Maintenance Order',
  Horsepower_Tax: 'Horsepower Tax',
  Number_of_Doors: 'Number Doors',
  Number_of_Seats: 'Number Seats',
  Type_of_Fuel: 'Type Fuel',
  Expected_total: 'Expected total',

  UpdateWorkOrder: 'Update Workorder',

  MaterialsIssued: 'Materials Issued',
  MaterialsNotIssued_: 'Materials Not Issued',
  MaterialsNotIssued: 'Materials not issued from inventory',
  MaterialsNotIssuedMessage:
    'All materials must be issued from inventory before closing the maintenance order. Please proceed to the inventory section to complete the issuance process.',
  CannotCloseUntilMaterialsIssued: 'Cannot close until materials are issued',
  Confirmed: 'Confirmed',
  NotConfirmed: 'Not Confirmed',
  ConfirmWorkOrder: 'Confirm Work Order',
  WorkOrderConfirmedSuccessfully: 'Work order confirmed successfully',
  MaintenanceOrderDetails: 'Maintenance Order Details',
  CLosingDetails: 'Closing details',
  NoNotesAvailable: 'No notes available',
  AddCompletionNotes: 'Add completion notes',
  Processing: 'Processing',
  AreYouSureConfirmWorkOrder: 'Are you sure you want to confirm this work order?',
  WorkOrderConfirmationNote: 'After confirmation, this action cannot be undone',
  ConfirmationFailed: 'Confirmation failed',
  orderConfirmedNoEdit: 'Order is confirmed and cannot be edited',

  State_of_Manufacture: 'State of Manufacture',
  Year_of_Manufacture: 'Year of Manufacture',
  Extra_Responsibilities: 'Extra Responsibilities',
  ExtraRecord: 'Extra Record',
  extrarecord: 'Extra Record',
  AddExtraRecordForm: 'Add Extra Record Form',
  ExtraRecordForm: 'Extra Record Form',
  DataTypesForms: 'Data Types Forms',
  ExtraInfoForm: 'Extra Information Form',
  AddExtraInfoForm: 'Add Extra Information Form',

  IsStatic: 'Is Static',
  StaticForms: 'Static Forms',

  From: 'From',
  To: 'To',

  OurTeam: 'Our Team',
  MyHolidays: 'My Holidays',
  MyRequests: 'My Requests',
  Requests: 'Requests',
  SendRequest: 'Send Request',
  Send: 'Send',

  ViewRequests: 'View Requests',
  ViewRequestDetails: 'View Request Details',
  MyInformation: 'My Information',
  NOTIFICATIONS: 'NOTIFICATIONS',

  UploadFile: 'Upload File',
  You_will_have_a_chance_to_rename_or_remove_columns_in_next_steps:
    'You will have a chance to rename or remove columns in next steps',
  SelectFile: 'Select File',
  Select_header_row: 'Select header row',
  Match_Columns: 'Match Columns',
  Your_table: 'Your table',
  Will_become: 'Will become',
  Match: 'Match',
  UnMatched: 'UnMatched',
  Columns_cannot_duplicate: 'Columns cannot duplicate',
  Validate_data: 'Validate data',
  Show_only_rows_with_errors: 'Show only rows with errors',
  Discord_selected_rows: 'Discord selected rows',
  Confirm: 'Confirm',
  Data_that_we_expect: 'Data that we expect',

  GeneralSystem: 'General System',
  HumanResources: 'Human Resources',
  ApprovalsManagement: 'Approvals Management',
  SupportingUnits: 'Supporting Units',
  Propertymanagement: 'Property management',
  FinancialSystem: 'Financial System',
  IntegrationWithSystems: 'Integration with systems',
  FleetManagement: 'Fleet Management',

  Add: 'Add',
  Edit: 'Edit',
  Country: 'Country',
  City: 'City',
  Religion: 'Religion',
  Show: 'Show',
  EmployeeModification: 'Employee Modification',
  ExtraInformation: 'Extra Information',
  ExtraInformationForms: 'Extra Information Forms',
  NameOfTheBank: 'Name of the bank',
  ChoosePhoto: 'Choose Photo',
  PostalCode: 'Postal Code',
  Region: 'Region',
  AddGrade: 'Add Grade',
  EditGrade: 'Edit Grade',
  EditJob: 'Edit Job',
  AddPosition: 'Add Position',
  SuperVisorLevel: 'Super Visor Level',
  Departments: 'Departments',
  OrganizationalStructure: 'Organizational Structure',
  AddDepartment: 'Add Department',
  InternalOrExternal: 'Internal/external',
  External: 'External',
  Internal: 'Internal',
  Note: 'Note',
  NoteComplate: 'Note Complate',
  Classification: 'Classification',
  Address: 'Address',
  Catagory: 'Catagory',

  CommercialRegistrationNumber: 'Commercial registration number',
  VatNumber: 'Vat Number',

  Reason: 'Reason',
  ChangeDate: 'Change Date',
  SalaryValue: 'Salary Value',
  PayrollElementEntry: 'Payroll Element Entry',
  RunPayrolls: 'Run Payrolls',
  Payrolls: 'Payrolls',
  PayrollSettings: 'Payroll Settings',
  PayrollElements: 'Payroll Elements',
  PayProposalHistory: 'Base Salary History',

  AddPayrollElement: 'Add Payroll Element',
  EditPayrollElement: 'Edit Payroll Element',
  AddPayroll: 'Add Payroll',
  UpdatePayroll: 'Edit Payroll',
  TypeOfDuration: 'Type of duration',
  Name: 'Name',

  LinkPayrollElements: 'Link Payroll Elements',
  LinkElementsfor: 'Link Elements for',
  NumberOfyears: 'Number of years',
  NumberOfDays: 'Number of days',
  PaymentMethod: 'Payment method',
  Currency: 'Currency',
  Recurring: 'Recurring',
  'Non-Recurring': 'Non-Recurring',
  InputOfType: 'input of Type',
  Elemente: 'Elemente',
  'Weekly ': 'Weekly',
  Monthly: 'Monthly',
  CreateRunPayrolls: 'Create Run Payrolls',
  AddRun: 'Add Run',
  CreateRun: 'Create Run',
  ShowAllRuns: 'Show All Runs',
  'Period-Month': 'Period - Month',
  StartOfPeriod: 'Start of Period',
  EndOfPeriod: 'End of Period',
  TypeRunPayroll: 'Type Run Payroll',
  SalaryStatement: 'Salary Statement',
  Approve: 'Approve',
  PrintAll: 'Print All',
  Print: 'Print',
  PayrollProcessedSuccessfully: 'Payroll processed successfully',
  Unpaid: 'Unpaid',
  Paid: 'Paid',

  Parent: 'Parent',
  child: 'child',
  Icon: 'Icon',
  Forms: 'Forms',
  SystemLists: 'System Lists',
  AddValues: 'Add Values',
  SystemListsAndForms: 'System Lists and Forms',
  AddForm: 'Add Form',
  EditForm: 'Edit Form',
  fieldsForm: 'fields Form',
  Form: 'Form',
  LetterRequestForm: 'Letter Request Form',
  AddfieldsForm: 'Add fields Form',
  EditfieldsForm: 'Edit fields Form',
  AddNewList: 'Add New List',
  Values: 'Values',
  'Sub-Lists': 'Sub Lists',
  'Lists&Forms': 'Lists and Forms',
  Value: 'Value',
  tableInTheSystem: 'table in the system',
  ConstructedList: 'Constructed list',
  Tables: 'Tables',
  ApprovalManagement: 'Approval Management',
  ApprovalGroup: 'Approval Group',
  CountMembers: 'Count Members',
  AddGroup: 'Add Group',
  AddNewGroup: 'Add New Group',
  EditGroup: 'Edit Group',

  RequestSettings: 'Request Settings',
  Jobs: 'Jobs',
  Locations: 'Locations',
  Jobgrades: 'Job grades',
  Positions: 'Positions',
  Staffgroup: 'Staff Group',
  AddNewJob: 'Add new job',
  AddJob: 'Add Job',
  AddNewJobDegree: 'Add new job degree',
  Longitude: 'Longitude',
  Latitude: 'Latitude',

  Applications: 'Applications',

  EditPosition: 'Edit position',
  AddNewStaffGroup: 'Add New Staff Group',
  AddStaffGroup: 'Add Staff Group',
  EditStaffGroup: 'Edit Staff Group',
  AddLocation: 'Add Location',
  EditLocation: 'Edit Location',
  RotationPlanRaqeeb: 'Rotation plan',
  AttendanceSummary: 'Attendance Summary',
  ExtraHours: 'Extra Hours',
  ExportData: 'Export Data',

  DataHasBeenUpdated: 'Data Has Been Updated',
  FailedDataUpdate: 'Failed Data Update',

  RotationPlan: 'Rotation Plan',
  ViewSchedulingDays: 'View scheduling days',
  AddRotationPlan: 'Add Rotation Plan',
  AttendanceAnalysis: 'Attendance Analysis',
  NumberOfFingerprints: 'Number of fingerprints',
  AllowIn: 'Allow In',
  AllowOut: 'Allow Out',
  PlanSettings: 'Plan Settings',
  RotationPlanSettings: 'Rotation Plan Settings',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  OneFingerprint: 'One Fingerprint',
  TowFingerprint: 'Tow Fingerprint',
  ThreeFingerprint: 'Three Fingerprint',
  FourFingerprint: 'Four Fingerprint',
  ExtraDay: 'ExtraDay',
  StatusOfPermanence: 'Status of permanence',
  UserName: 'User Name',
  Password: 'Password',
  SignIn: 'Sign In',
  Responsibilities: 'Responsibilities',
  AddUser: 'Add User',
  UserManagement: 'User Management',
  PayrollManagement: 'Payroll Management',
  PayrollsSettings: 'Payrolls Settings',
  OnlyEnglishLettersAreAllowed: 'Only English letters are allowed',
  OnlyEnglishLettersAndSomeSymbolsAreAllowed: 'Only English letters and some symbols are allowed',

  MobileNumber: 'Mobile Number',
  Email: 'Email',
  Fax: 'Fax',
  Phone: 'Phone',
  TypeOfUser: 'Type of User',
  UsernameAlreadyExists: 'Username Already Exists',

  UserEdit: 'User Edit',

  Responsibility: 'Responsibility',

  RequestsSettings: 'Requests settings',
  Conditions: 'Conditions',
  Condition: 'Condition',
  ConditionDescription: 'Condition Description',
  Rules: 'Rules',
  Field: 'Field',
  TheFirstVariable: 'The first variable',
  TheSecondVariable: 'The Second variable',
  GroupMembers: 'Group members',
  AddGroupMembers: 'Add group Members',
  Member: 'Member',
  Order: 'Order',
  DetailsOfAbsence: 'Details of Absence',
  Date: 'Date',
  NewRequest: 'New Request',
  SelfServiceRequests: 'Self-service requests',
  Procedure: 'Procedure',
  Comments: 'Comments',

  Request: 'Request',
  RequestStatus: 'Request Status',
  RequestsInProgress: 'Requests In Progress',

  BasicData: 'Basic Data',
  ContractNumber: 'Contract Number',
  ContractDate: 'Contract Date',
  ContractStatus: 'Contract Status',
  ContractTerm: 'Contract Term',
  ContractStartDate: 'Contract Start Date',
  ContractEndDate: 'Contract End Date',

  FinancialData: 'Financial Data',
  AmountRent: 'Amount Rent',
  AmountVat: 'Amount Vat',
  PayEvery: 'Pay Every',
  CountInstallments: 'Count Installments',
  AmountInstallment: 'Amount Installment',
  Automatic_Renewal: 'Automatic Renewal',

  Services: 'Services',

  PaymentDate: 'Payment Date',
  BankReference: 'Bank Reference',
  ExchangeRate: 'Exchange Rate',

  Maintenance: 'Maintenance',
  Settings: 'Settings',
  Driver: 'Driver',
  driver: 'Driver',
  Owner: 'Owner',

  AlltemsRequired: 'All Items Required',

  Description: 'Description',
  Attachment: 'Attachment',
  DateCompletion: 'Date Completion',
  actual_implementation_start_date: 'actual implementation start date',
  actual_implementation_end_date: 'actual implementation end date',

  OrderAlreadyClosed: 'Order Already Closed',
  OrderClosedOnDate: 'Order Closed OnDate',

  Exit_import_flow: 'Exit import flow',
  Are_you_sure_Your_current_information_will_not_be_saved: 'Are you sure? Your current information will not be saved.',
  Columns_not_matched: 'Columns not matched',
  There_are_required_columns_that_are_not_matched_or_ignored_Do_you_want_to_continue:
    'There are required columns that are not matched or ignored. Do you want to continue',
  Not_all_columns_matched: 'Not all columns matched',
  Continue: 'Continue',
  SelectAll: 'Select All',
  UnSelectAll: 'UnSelect All',

  Horsepower: 'Horsepower',
  Barcodes: 'Barcodes',
  Transmission: 'Transmission',

  TemporarySave: 'Temporary Save',
  Debt: 'Debt',
  Debit: 'Debit',
  Credit: 'Credit',
  CostCenter: 'CostCenter',
  Accounts: 'Accounts',
  Company: 'Company',
  Category: 'Category',
  AccountingPeriod: 'Accounting Period',

  Operations: 'Operations',
  PaymentInvoices: 'Payment Invoices',
  PostPaymentInvoices: 'Post Payment Invoices',
  PaymentVouchers: 'Payment Vouchers',
  PostPaymentVouchers: 'Post Payment Vouchers',
  Expenses: 'Expenses',
  InvoicePayments: 'Invoice Payments',
  PaymentTerms: 'Payment Terms',
  Currencies: 'Currencies',
  TypesOfExpenses: 'Types of Expenses',

  SupplierName: 'Supplier Name',
  SupplierNumber: 'Supplier Number',
  TradingName: 'Trading Name',
  SupplierDetails: 'Supplier Details',
  ContactInformation: 'Contact Information',
  ContactInformationForSupplier: 'Contact Information for Supplier',
  AddNewSupplier: 'Add New Supplier',

  Display: 'Display',
  Records: 'Records',
  SearchPlaceholder: 'Search here...',

  SupplierType: 'Supplier Type',

  CompanyRegistrationNumber: 'Company Registration Number',
  NationalInsuranceNumber: 'National Insurance Number',

  InvoiceCurrency: 'Invoice Currency',
  PaymentCurrency: 'Payment Currency',
  InvoiceLimit: 'Invoice Limit',
  CreditLimit: 'Credit Limit',
  BankAccountName: 'Bank Account Name',
  BankAccountNumber: 'Bank Account Number',
  BankNumber: 'Bank Number',
  BankAccountType: 'Bank Account Type',
  Account: 'Account',
  PrepaymentAccount: 'Prepayment Account',
  SetOfBooks: 'Set of Books',
  VATCode: 'VAT Code',
  VerificationNumber: 'Verification Number',
  WorkReference: 'Work Reference',
  ShipToLocation: 'Ship To Location',
  BillToLocation: 'Bill To Location',
  PaymentPriority: 'Payment Priority',

  PersonalAndContactInformation: 'Personal and Contact Information',
  FinancialAndBankingInformation: 'Financial and Banking Information',
  InstitutionalLegalIdentity: 'Institutional/Legal Identity',
  LocationAndPayment: 'Location and Payment',

  AddBranchForSupplier: 'Add Branch For Supplier',
  SupplierBranches: 'Supplier Branches',
  WebsiteLink: 'Web site Link',

  ExpenseTypes: 'Expense Types',
  Choose: 'Choose',
  CategoryName: 'Category Name',
  SourceName: 'Source Name',
  CategoryItems: 'Category Items',
  ExpenseCategoryItems: 'Expense Category Items',

  'Button.Edit': 'Edit',
  AddPaymentTerm: 'Add New Term',
  Period: 'Period',
  PaymentTerm: 'Payment Term',

  AddCurrency: 'Add New Currency',
  State: 'State',

  CurrencyName: 'Currency Name',
  CurrencyCode: 'Currency Code',

  NewInvoice: 'New Invoice',
  Details: 'Details',
  InvoiceNumber: 'Invoice Number',
  InvoiceDate: 'Invoice Date',
  InvoiceType: 'Invoice Type',
  Amount: 'Amount',
  PostingStatus: 'Posting Status',
  Posted: 'Posted',
  NotPosted: 'Not Posted',
  AddNewInvoice: 'Add New Invoice',

  SupplierInvoiceNumber: 'Supplier Invoice Number',

  CurrencyConversionRate: 'Currency Conversion Rate',

  InvoiceLines: 'Invoice Lines',
  InvoiceSchedule: 'Invoice Schedule',
  Standard: 'Standard',
  DebitMemo: 'Debit Memo',
  CreditMemo: 'Credit Memo',
  Prepayment: 'Prepayment',
  Prepayments: 'Prepayments',
  Warning: 'Warning',

  PrepaymentMessage: 'This supplier has prepayments totaling:',
  InvoiceLinesRequired: 'Invoice lines are required',
  InvoiceScheduleRequired: 'Invoice schedule is required',

  InvoiceDetails: 'Invoice Details',
  AddNewLine: 'Add New Line',
  Quantity: 'Quantity',
  Price: 'Price',
  DiscountRate: 'Discount Rate',
  DiscountAmount: 'Discount Amount',
  VAT: 'VAT',
  'VAT %': 'VAT %',
  AccountDetails: 'Account Details',
  'Add New Item': 'Add New Item',
  IncludeVAT: 'Include VAT',
  ExcludeVAT: 'Exclude VAT',

  PostSelectedInvoices: 'Post Selected Invoices',

  GeneralLedger: 'General Ledger',
  Post: 'Post',

  InvalidDateInPeriod: 'The date is not within the accounting period',
  PostSuccessMessage: 'Post successful',

  PaymentNumber: 'Payment Number',

  InvoiceAmount: 'Invoice Amount',
  RemainingAmount: 'Remaining Amount',
  DueDate: 'Due Date',
  PaymentType: 'Payment Type',

  FetchInvoices: 'Fetch Invoices',
  Submit: 'Submit',
  Ok: 'Ok',
  PaySelectedInvoices: 'Pay Selected Invoices',
  PrePayment: 'Pre-Payment',
  PrePaymentTotal: 'Pre-Payment Total',

  'Bank / Fund': 'Bank / Fund',
  Banks: 'Banks',
  NewBank: 'New Bank',
  EditBank: 'Edi tBank',
  AddBank: 'Add Bank',

  PrePaymentAmount: 'Pre-Payment Amount',
  AddNewPaymentVoucher: 'Add New Payment Voucher',

  Pay: 'Pay',

  InvoiceTotal: 'Invoice Total',

  PaymentAmount: 'Payment Amount',
  AmountToPay: 'Amount to Pay',
  Delete: 'Delete',

  Error: 'Error',

  ManagePayments: 'Manage Payments',
  VoucherNumber: 'Voucher Number',

  VoucherType: 'Voucher Type',

  PostedStatus: 'Posted Status',
  PostSelectedVouchers: 'Post Selected Vouchers',

  ExpenseCategory: 'Expense Category',
  ExpenseDate: 'Expense Date',
  TotalAmount: 'Total Amount',

  welcome: 'Welcome',
  neatix: 'Neatix',
  hr: 'Human Resources',
  payrollManagement: 'Payroll Management',
  attendanceManagement: 'Attendance Management',
  approvalsManagement: 'Approvals Management',
  financeManagement: 'Finance Management',
  payablesManagement: 'Payables Management',
  receivablesManagement: 'Receivables Management',
  inventoryManagement: 'Inventory Management',
  purchaseManagement: 'Purchase Management',
  salesManagement: 'Sales Management',
  posManagement: 'Point of Sale Management',
  reportsManagement: 'Reports and Print Templates Management',
  notificationsSystem: 'Notifications System',
  assetsManagement: 'Assets Management',
  fleetManagement: 'Fleet Management',
  supportingUnits: 'Supporting Units Management',
  integrationManagement: 'Integration Management',
  cashManagement: 'Cash Management',

  projectManagement: 'Project Management',
  taskManagement: 'Task Management',
  productionManagement: 'Production Management',

  Customers: 'Customers',
  ReceivablesInvoices: 'Receivables Invoices',
  PostReceivablesInvoices: 'Post Receivables Invoices',
  Receipts: 'Receipts',
  PostReceipts: 'Post Receipts',

  CustomerName: 'Customer Name',
  CustomerNumber: 'Customer Number',
  CustomerDetails: 'Customer Details',
  CustomerContactInformation: 'Customer Contact Information',
  AddNewCustomer: 'Add New Customer',

  Customer: 'Customer',
  customer: 'Customer',
  ReceivableInvoices: 'Receivable Invoices',

  ReceivablesTransactions: 'Receivables Transactions',
  AddNewTransaction: 'Add New Transaction',
  ShippingLocation: 'Shipping Location',
  BillingLocation: 'Billing Location',
  CustomerInvoiceNumber: 'Customer Invoice Number',
  SalesRepresentative: 'Sales Representative',

  ReceiptNumber: 'Receipt Number',
  ReceiptType: 'Receipt Type',
  NewReceipt: 'New Receipt',

  PrePaymentValue: 'Value',
  SettleSelectedInvoices: 'Settle Selected Invoices',
  BatchNumber: 'Batch Number',

  BankAccount: 'Bank / Cashbox',
  Receipt: 'Receipt',
  AddNewReceipt: 'Add New Receipt',
  Retry: 'Retry',
  PostSelectedReceipts: 'Post Selected Receipts',

  Inventories: 'Inventories',
  SubInventories: 'Sub Inventories',
  AddSubInventory: 'Add Sub Inventory',
  NewSubInventory: 'New SubInventory',
  AddInventory: 'Add Inventory',
  NewInventory: 'New Inventory',
  EditInventory: 'EditInventory',
  SubInventory: 'SubInventory',
  Items: 'Items',

  ManageInventoryItems: 'Manage Inventory Items',
  ItemsNotInInventory: 'Items not in this inventory',
  AddToInventory: 'Add to Inventory',
  ItemsInInventory: 'Items currently in this inventory',
  RemoveFromInventory: 'Remove from Inventory',

  Categories: 'Categories',
  AddMainCategory: 'Add Main Category',
  AddCategory: 'Add Category',
  AddNewItem: 'Add New Item',
  ViewProductImages: 'View Product Images',
  MeasurementUnits: 'Units of Measure',

  TransactionTypes: 'Transaction Types',

  NewReason: 'New Reason',
  AddReasons: 'Add Reasons',
  UpdateReasons: 'Edit Reasons',
  NewAttribute: 'New Attribute',
  ItemAttributes: 'Item Attributes',
  AddNewAttribute: 'Add New Attribute',
  EditAttribute: 'Edit Attribute',
  AssignmentAttribute: 'Assignment Attribute to Multi Items',
  ExtraPrice: 'Extra Price',
  Color: 'Color',

  FillBasicItemDataToAddToInventory: 'Fill basic item data to add to inventory',
  Pricing: 'Pricing',
  EnterLocalName: 'Enter local name',
  EnterGlobalName: 'Enter global name',
  EnterBarcode: 'Enter barcode',
  ItemCode: 'Item Code',
  EnterItemCode: 'Enter item code',
  ItemCategory: 'Item Category',
  ItemType: 'Item Type',
  UnitOfMeasure: 'Unit of Measure',
  DistributionMethod: 'Distribution method',
  SalesPrice: 'Sales Price',
  PurchasePrice: 'Purchase Price',
  UpperDemandLimit: 'Upper Demand Limit',
  LowerDemandLimit: 'Lower Demand Limit',
  ItemSettings: 'Item Settings',
  ServiceItem: 'Service Item',
  InventoryItem: 'Inventory Item',
  TrackInventory: 'Track Inventory',
  EnableCustomerOrders: 'Enable Customer Orders',
  AvailableForSale: 'Available for Sale',
  EnablePurchasing: 'Enable Purchasing',
  InternalTransfer: 'Internal Transfer',
  AllowNegativeStock: 'Allow Negative Stock',
  BackToBasic: 'Back to Basic',
  BackToPricing: 'Back to Pricing',
  ContinueToPricing: 'Continue to Pricing',
  ContinueToSettings: 'Continue to Settings',
  AddItem: 'Add Item',

  ItemDetails: 'Item Details',
  ItemData: 'Item Data',
  ItemUnits: 'Item Units',
  LotNumbers: 'Lot Numbers',
  ProductImage: 'Product Image',
  ItemSuppliers: 'Item Suppliers',

  ConversionValue: 'Conversion Value',
  Unit: 'Unit',
  NoUnitsForItem: 'No units for this item',
  ConfirmDelete: 'Are you sure you want to delete?',
  LotNumber: 'Lot Number',
  ExpirationDate: 'Expiration Date',
  Attribute: 'Attribute',
  NoAttributesForItem: 'No attributes for this item',

  SelectAlternativeItems: 'Select Alternative Items',
  SelectItemSuppliers: 'Select suppliers for this item',

  IssuanceReasons: 'Issuance Reasons',
  AdditionReasons: 'Addition Reasons',
  UpdateReason: 'Update Reason',
  LocalDescription: 'Local Description',

  NewBrand: 'New Brand',
  EditBrand: 'Edit Brand',

  TransactionDate: 'Transaction Date',
  ReferenceNumber: 'Reference Number',
  ReferenceType: 'Reference Type',
  PurchaseReturn: 'Purchase Return',
  TransferOrderIssue: 'Transfer Order Issue',
  SalesOrder: 'Sales Order',
  Issue: 'Issue',
  RawMaterialIssue: 'Raw Material Issue',
  FinalProductReceipt: 'Final Product Receipt',
  TransferReceipt: 'Transfer Receipt',
  Addition: 'Addition',
  PurchaseOrder: 'Purchase Order',

  // "InvIssue": "Inventory Issue",
  // "AddInvIssue": "Add Issue",
  TransferOrder: 'Transfer Order',
  IssueDocument: 'IssueDocument',
  // "OperatingUnit": "Operating Unit",
  TransactionType: 'Transaction Type',
  StoreKeeper: 'Store Keeper',
  SelectOperatingUnitInventoryTransaction: 'Select Operating Unit, Inventory and Transaction Type',
  PleaseSelectOperatingUnitInventoryTransactionType:
    'Please select operating unit, inventory, and transaction type to proceed',
  Select: 'Select',

  UpdateInvIssue: 'Update Issue',
  EditIssuePermission: 'Edit Issue Permission',
  Reference: 'Reference',
  JournalDetails: 'Journal Details',

  ItemName: 'Item Name',
  AllLots: 'All Lots',
  AvailableQuantity: 'Available Quantity',
  DispensedQuantity: 'Dispensed Quantity',
  FullyProcessed: 'Fully Processed',
  RemainingQuantity: 'Remaining Quantity',
  ReservedQuantity: 'Reserved Quantity',
  InventoryDetails: 'Inventory Details',
  None: 'None',
  TransferIssue: 'Transfer Issue',

  EditItem: 'Edit Item',
  Sections: 'Sections',
  Units: 'Units',
  ItemWarehouses: 'Item Warehouses',
  ItemInventory: 'Item inventories',
  ItemImage: 'Item Image',

  ReceivePermission: 'Receive Permission',
  NewReceivePermission: 'New Receive Permission',
  EditReceivePermission: 'Edit Receive Permission',
  CannotEditAfterPosting: 'Sorry, you cannot edit after posting. Thank you for your understanding.',
  RecordPosted: 'Record Posted',

  NewLotNumber: '🆕 New Lot Number',
  PreviouslyAddedQuantity: 'Previously Added Quantity',
  AddedQuantity: 'Added Quantity',

  SelectSalesInvoice: 'Select Sales Invoice',
  SelectSalesOrder: 'Select Sales Order',
  SelectTransferDocument: 'Select Transfer Document',
  SelectTransferOrder: 'Select Transfer Order',
  SelectPurchaseReturn: 'Select Purchase Return',
  SelectPurchaseInvoice: 'Select Purchase Invoice',
  SelectPurchaseOrder: 'Select Purchase Order',
  SelectSalesReturn: 'Select Sales Return',
  SelectTransferReceipt: 'Select Transfer Receipt',
  SelectAdditionReason: 'Select Addition Reason',
  SelectIssueReason: 'Select Issue Reason',
  SelectMaintenanceOrder: 'Select Maintenance Order',
  SelectReference: 'Select Reference',
  LoadingData: 'Loading data',
  FailedToLoadData: 'Failed to load data',

  ErrorLoadingData: 'Error loading data',
  Filters: 'Filters',
  DateRange: 'Date Range',
  SelectDateRange: 'Select date range',
  ResetFilters: 'Reset Filters',
  LoadReport: 'Load Report',
  Loading: 'Loading...',
  LoadingStockCardData: 'Loading stock card data...',
  TransactionCode: 'Transaction Code',
  QuantityIn: 'Quantity In',
  QuantityOut: 'Quantity Out',
  UnitPrice: 'Unit Price',
  TotalQuantity: 'Total Quantity',
  NoDataAvailable: 'No data available. Set your filters and click "Load Report" to generate.',
  ReportGeneratedOn: 'Report generated on',
  ItemRequired: 'Item is required',
  UnknownError: 'An unknown error occurred',
  OpeningBalance: 'Opening Balance',

  confirmPostMessage: 'Are you sure you want to post the selected transactions?',
  // "PostSuccessMessage": "Transactions posted successfully",
  PostErrorMessage: 'An error occurred during posting',
  transactionType: 'Transaction Type',
  transactionCode: 'Transaction Code',
  status: 'Status',
  Pending: 'Pending',
  ProcessingResults: 'Processing Results',
  Summary: 'Summary',
  // "Details": "Details",
  TotalTransactions: 'Total Transactions',
  Successful: 'Successful',
  Failed: 'Failed',
  code: 'Code',
  type: 'Type',
  errorMessage: 'Error Message',
  Success: 'Success',
  SomeTransactionsFailed: 'Some transactions failed to post',
  DownloadErrorReport: 'Download Error Report',
  // "Processing": "Processing",
  // "Post": "Post",
  // "Cancel": "Cancel",
  Close: 'Close',
  PostInventoryToAccounting: 'Post Inventory',
  selectedTransactionsCount: 'transactions selected for posting',
  AllOperationsFailed: 'All operations failed',
  operationsSucceeded: 'operations succeeded and',
  operationsFailed: 'operations failed',

  PurchaseRequestNumber: 'Purchase Request Number',
  PurchaseRequestDate: 'Purchase Request Date',
  Inventory: 'Inventory',
  SendToSuppliers: 'Send to Suppliers',
  AddNewPurchaseRequest: 'Add New Purchase Request',
  PurchaseRequests: 'Purchase Requests',
  Purchases: 'Purchases',
  Quotations: 'Quotations',
  PurchaseOrders: 'Purchase Orders',
  PurchaseReturns: 'Purchase Returns',
  ReceiveNoneInventoryItems: 'Receive Non-Inventory Items',

  CCSIDOTP: 'CCSID OTP',
  GetCCSID: 'Get CCSID',
  CCSIDBinaryToken: 'CCSID Binary Token',
  TokenSecret: 'Token Secret',
  RequestID: 'Request ID',
  GetPCSID: 'Get PCSID',
  PCSIDBinaryToken: 'PCSID Binary Token',
  PCSIDSecret: 'PCSID Secret',
  RegisteredDate: 'Registered Date',
  CSRInformation: 'CSR Information',
  CSRIndustryBusinessCategory: 'Industry Business Category',
  CSRCommonName: 'Common Name',
  CSRSerialNumber: 'Serial Number',
  CSROrganizationIdentifier: 'Organization Identifier',
  CSROrganizationUnitName: 'Organization Unit Name',
  CSROrganizationName: 'Organization Name',
  CSRCountryName: 'Country Name',
  CSRInvoiceType: 'Invoice Type',
  CSRLocationAddress: 'Location Address',
  CSREnvironmentType: 'Environment Type',
  EnvironmentTypePlaceholder: 'Production or Non-Production',
  GenerateCSR: 'Generate CSR',
  GeneratedCSR: 'Generated CSR',
  GeneratedPrivateKey: 'Generated EC Secp256k1 Private Key (PEM)',
  BusinessInformation: 'Business Information',
  RegistrationName: 'Registration Name',
  RegistrationNamePlaceholder: 'Company Name',
  CompanyID: 'Company ID',
  TaxSchemeID: 'Tax Scheme ID',
  BusinessID: 'Business Identification ID',
  IdentificationScheme: 'Identification Scheme',
  StreetName: 'Street Name',
  CityName: 'City Name',
  CitySubdivisionName: 'City Subdivision Name',
  BuildingNumber: 'Building Number',
  PostalZone: 'Postal Zone',
  CountryCode: 'Country Identification Code',
  BusinessCategory: 'Business Category',
  BusinessCategoryPlaceholder: 'Supply Activities',

  Warehouses: 'Warehouses',
  UnitsOfMeasure: 'Units of Measure',
  Brand: 'Brand',
  BatchAndExpiryDates: 'Batch and Expiry Dates',
  Attributes: 'Attributes',
  InvIssue: 'Issue Document',
  InvReceive: 'Receive Document',
  InvMove: 'Transfer Documents',
  UpdateCost: 'Update Costs',
  Allocate: 'Allocate',
  CreateAccountInventory: 'Account Inventory Entries',
  InventoryCount: 'Inventory Count',
  PhysicalInventory: 'Physical Inventory',
  InventoryResults: 'Inventory Results',

  TransType: 'Transaction Type',
  Number: 'Number',
  Action: 'Action',
  AddInvIssue: 'Add New Issue',
  AddInvReceive: 'Add New Receive',

  Sales: 'Sales',
  SellOrder: 'Sell Orders',
  SalesReturn: 'Sales Return',
  PriceList: 'Price List',
  Vouchers: 'Vouchers',

  NewQuotation: 'New Quotation',
  SendToCustomer: 'Send to Customer',

  SalesOrders: 'Sales Orders',
  NewSalesOrder: 'New Sales Order',
  NewSalesOrderFromQuotation: 'Create Sales Order from Quotation',
  Delivered: 'Delivered',
  NotDelivered: 'Not Delivered',

  SalesOrderNumber: 'Sales Order Number',
  SalesOrderDate: 'Sales Order Date',

  Return: 'Return',
  Collapse: 'Collapse',
  Expand: 'Expand',
  SubList: 'SubList',
  MainList: 'Main List',
  AddPriceList: 'Add a New Price List',
  PriceLists: 'Price Lists',
  AddNewPriceList: 'New Price List',
  EditPriceList: 'Edit Price List',
  PurchaseRequest: 'Purchase Request',
  QuotationComparison: 'Quotation Comparison',
  NewAttendanceRequest: 'New Attendance Request',
  AttendanceRequests: 'Attendance Requests',
  AddNewAttendanceRequest: 'Add New Attendance Request',
  EditNewAttendanceRequest: 'Edit New Attendance Request',
  EditHoliday: 'Edit Leave',
  AddNewHoliday: 'Add New Leave',
  NewHoliday: 'New Leave',
  Holidays: 'Leaves',

  FiscalYear: 'Fiscal Year',
  StartDate: 'Start Date',
  EndDate: 'End Date',
  AddFiscalYear: 'Add Fiscal Year',
  EditFiscalYear: 'Edit Fiscal Year',
  StartOfYear: 'Start of Year',
  EndOfYear: 'End of Year',
  Start: 'Start Period',
  End: 'End Period',
  ClosePeriod: 'Close Period',
  CloseAccountingPeriod: 'Close Accounting Period',
  AccountingPeriods: 'Accounting Periods',
  AddAccountingPeriod: 'Add Accounting Period',
  EditAccountingPeriod: 'Edit Accounting Period',

  AddGeneralLedger: 'Add General Ledger',
  EditGeneralLedger: 'Edit General Ledger',
  ChartOfAccounts: 'Chart of Accounts',

  FromDate: 'From Date',
  ToDate: 'To Date',
  Rate: 'Rate',
  New: 'New',
  DailyRates: 'Daily Exchange Rates',

  JeSource: 'Journal Entry Sources',
  AddJeSource: 'Add New Source',
  EditJeSource: 'Edit Source',

  JeCategories: 'Journal Entry Categories',
  AddJeCategory: 'Add New Category',
  EditJeCategory: 'Edit Category',

  Tax: 'Vat',
  TaxType: 'Tax Type',
  TaxRate: 'Tax Rate',
  TaxCategory: 'Tax Category',
  AddNewTax: 'Add New Vat',
  EditTax: 'Edit Vat',

  AdministrativeEntity: 'Administrative Entity',
  FinancialAccount: 'Financial Account',
  MainAccount: 'Main Account',
  Actions: 'Actions',
  NotLinked: 'Not Linked',
  Link: 'Link',
  RemoveLink: 'Remove Link',
  DepartmentsLinking: 'Departments Linking',
  LinkingAdministrativeEntityToAccounts: 'Linking the Administrative Entity to Accounts',
  Companies: 'Companies',
  CostCenters: 'Cost Centers',

  NewExpenseType: 'New Expense Type',

  NameBank: 'Bank Name',
  NoBank: 'Bank Account Number',
  Iban: 'IBAN',
  BankAccounts: 'Bank Accounts',
  Bank: 'Bank',
  NewBankAccount: 'New Bank Account',
  AddBankAccount: 'Add New Bank Account',
  EditBankAccount: 'Edit Bank Account',

  CloseSessionConfirmation: 'Do you want to close the session with a total amount of ({{amount}})?',
  SessionClosedSuccessfully: 'The session was closed successfully.',

  CashBoxes: 'Cash Boxes',
  NewCashBox: 'New Cash Box',
  AddCashBox: 'Add New Cash Box',
  EditCashBox: 'Edit Cash Box',

  CodeCannotContainSpaces: 'Code Cannot Contain Spaces',

  maxPerCustomerLabel: 'Maximum Number Allowed Per Customer',
  maxPerCustomerHelp: 'If the value is 0, it means unlimited.',
  itemsSelectHint: 'No items selected means all items are included.',
  posSelectHint: 'No points of sale selected means all are included.',
  MustBeZeroOrMore: 'Must be zero or more',
  MustBeOneOrMore: 'Must be one or more',
  'Must be greater than 0': 'Must be greater than 0',
  'At least one free item required': 'At least one free item required',
  SelectItems: 'Select items',

  Registered: 'Registered',
  Unregistered: 'Unregistered',
  RegistrationRequest: 'Registration request',
  Unknown: 'Unknown',
  IsActive: 'Active',
  SessionOpen: 'Session Open',
  SessionClosed: 'Session Closed',
  PointOfSaleName: 'Point of Sale Name',
  AffiliatedBranch: 'Affiliated Branch',
  LinkedInventory: 'Linked Inventory',
  SessionStatus: 'Session Status',
  RegistrationStatus: 'Registration Status',
  SessionManagerName: 'Session Manager Name',
  PointOfSaleSettings: 'Point of Sale Settings',
  NewPointOfSale: 'New Point of Sale',
  ApprovePointOfSaleRegistration: 'Approve Point of Sale Registration',

  OperatingUnit: 'Operating Unit',
  ShowProductImage: 'Show Product Image',
  ShowCategory: 'Show Category',
  AlternativeItems: 'Alternative Items',
  PromotionalOffers: 'Promotional Offers',
  CashCustomer: 'Cash Customer',
  PointOfSaleInformation: 'Point of Sale Information',
  InvoiceHeader: 'Invoice Header',
  InvoiceFooter: 'Invoice Footer',

  Cashier: 'Cashier',
  AddCashier: 'Add Cashier',
  CashierName: 'Cashier Name',
  DeleteItem: 'Delete Item',
  UpdatePrice: 'Update Price',
  ReturnInvoice: 'Return Invoice',
  Activated: 'Activated',
  Deactivated: 'Deactivated',
  EditCashier: 'Edit Cashier',
  Info: 'Info',
  NotSpecified: 'Not Specified',

  PointsOfSale: 'Points of Sale',
  PointOfSaleDetails: 'Point of Sale Details',

  UpdatePricePermission: 'Update Price Permission',
  DeleteItemPermission: 'Delete Item Permission',
  ReturnInvoicePermission: 'Return Invoice Permission',

  PaymentMethods: 'Payment Methods',
  AddPaymentMethod: 'Add Payment Method',
  PointOfSale: 'Point of Sale',
  AlreadyAdded: 'Already added',

  PosRegistration: 'POS Registration',
  Deleting: 'Deleting...',
  DeleteDeviceRegistration: 'Delete Device Registration',
  OperatingSystem: 'Operating System',
  DeviceType: 'Device Type',
  DeviceId: 'Device ID',
  ThisPosNotRegistered: 'This POS is not registered.',
  LoadingDeviceDetails: 'Loading device details...',
  PosRegistrationDeletedSuccessfully: 'POS registration deleted successfully.',
  FailedToDeletePosRegistration: 'Failed to delete POS registration.',
  UnexpectedError: 'An unexpected error occurred. Please try again.',
  Approved: 'Approved',
  Rejected: 'Rejected',
  PendingApproval: 'Pending Approval',
  ConfirmDeletePosRegistration: 'Are you sure you want to delete this POS registration?',

  AssemblyItem: 'Assembly Item',
  FixedAssetItem: 'Fixed Asset Item',
  ExpenseItem: 'Expense Item',

  TotalItems: 'Total items',
  InventoryItems: 'Inventory items',
  ServiceItems: 'Service items',
  AssemblyItems: 'Assembly items',

  ItemsRegister: 'Items List',

  SearchItemsPlaceholder: 'Search by item name, code, or barcode...',
  ClearSearch: 'Clear search',
  SearchFilters: 'Search filters',

  NoSearchResults: 'No search results',
  NoItemsRegistered: 'No items registered',

  ShowingItems: 'Showing {{shown}} of {{total}} items',
  SearchResultsFor: 'Search results for: "{{term}}"',

  SortResults: 'Sort results',
  SearchFiltersAndSorting: 'Search filters & sorting',

  FilterSettings: 'Filter settings',
  AddFilter: 'Add filter',
  NoFiltersAdded: 'No filters added',
  AddFilterHint: 'Click "Add filter" to start creating search conditions',
  SelectFieldPlaceholder: 'Select field...',
  DeleteFilter: 'Delete filter',

  SortSettings: 'Sort settings',
  AddSort: 'Add sort',
  NoSortsAdded: 'No sorts added',
  AddSortHint: 'Click "Add sort" to start creating sorting rules',
  SelectSortFieldPlaceholder: 'Select sort field...',
  DeleteSort: 'Delete sort',

  SelectFieldFirst: 'Select a field first',
  EnterNumber: 'Enter a number',
  EnterSearchValue: 'Enter search value',
  // Select: 'Select',
  // Yes: 'Yes',
  // No: 'No',

  SortAscendingOption: '↗ Ascending (smallest to largest)',
  SortDescendingOption: '↘ Descending (largest to smallest)',

  ActiveFiltersLabel: 'Active filters:',
  Reset: 'Reset',
  ApplyFilters: 'Apply filters',
  Applying: 'Applying...',

  OpEquals: 'Equals',
  OpNotEquals: 'Not equals',
  OpGreaterThan: 'Greater than',
  OpGreaterOrEqual: 'Greater than or equal',
  OpLessThan: 'Less than',
  OpLessOrEqual: 'Less than or equal',
  OpContains: 'Contains',
  OpStartsWith: 'Starts with',
  OpEndsWith: 'Ends with',

  // Standard: 'Standard',
  Custom: 'Custom',
  StandardReport: 'Standard report',
  CustomReport: 'Custom report',

  ReportsCountLabel: '{{count}} report(s)',

  SearchReportsPlaceholder: 'Search by report or module name...',

  NoReportsFound: 'No reports found',
  TryDifferentSearch: 'Try a different search',
  NoReportsAvailable: 'No reports available',
  ShowAllReports: 'Show all reports',

  ClosePreview: 'Close preview',

  WelcomeReportManagerTitle: 'Welcome to the report manager',
  WelcomeReportManagerDescription:
    'Select a report from the sidebar to preview it. You can browse standard or custom reports based on your needs.',

  ReportFilters: 'Report filters',
  ReportResults: 'Report results',

  // ClearAll: 'Clear all',
  LoadData: 'Load data',
  LoadingDataShort: 'Loading...',

  LoadingReportDataTitle: 'Loading data',
  PleaseWait: 'Please wait...',

  ReportRecordsCount: '{{count}} record(s)',
  LastUpdateTime: 'Last updated: {{time}}',

  NoReportDataTitle: 'No data',
  NoReportDataDescription: 'Set the required filters and click "Load data" to display the report results.',

  InventoryTransactionStartTitle: 'Start a new inventory transaction',
  InventoryTransactionStartSubtitle: 'Choose the appropriate inventory transaction type',

  NoTransactionTypesAvailable: 'No transaction types available',
  CheckPermissionsOrSettings: 'Please check permissions or system settings',

  BackToTransactionTypeSelection: 'Back to transaction type selection',

  SelectOperatingUnitPlaceholder: 'Select operating unit',
  SelectInventoryPlaceholder: 'Select inventory',

  FetchData: 'Fetch data',
  FetchingData: 'Loading...',

  ReferenceFetchErrorMessage: 'An error occurred while fetching data. Please try again.',

  NoReferenceDataTitle: 'No data available',
  NoReferenceDataDescription: 'No references were found for this transaction type',

  StartTransaction: 'Start transaction',
  CompleteSelections: 'Complete selections',

  TransType_RFG_Title: 'Receive finished goods from production',
  TransType_MOR_Title: 'Receive materials from transfer order',
  TransType_MIR_Title: 'Add materials to inventory',
  TransType_POR_Title: 'Purchase order',
  TransType_CRT_Title: 'Sales return',
  TransType_CRP_Title: 'POS sales return',
  TransType_INV_Title: 'Sales invoice',
  TransType_SOI_Title: 'Sales order',
  TransType_SOP_Title: 'POS sales order',
  TransType_MOI_Title: 'Transfer order between warehouses',
  TransType_SPR_Title: 'Purchase return',
  TransType_SRP_Title: 'Purchase return from order',
  TransType_BIL_Title: 'Purchase invoice',
  TransType_IOR_Title: 'Incoming transfer receipt',
  TransType_WOI_Title: 'Work order',
  TransType_CCA_Title: 'Issue materials',
  TransType_MII_Title: 'Inventory adjustment',

  TransTypeName_POR: 'Purchase orders',
  TransTypeName_INV: 'Sales invoices',
  TransTypeName_CRT: 'Sales returns',
  TransTypeName_CRP: 'POS sales returns',
  TransTypeName_MOR: 'Transfer orders',
  TransTypeName_IOR: 'Transfer receipts',
  TransTypeName_BIL: 'Purchase invoices',
  TransTypeName_MIR: 'Receipt reasons',
  TransTypeName_MII: 'Inventory adjustment reasons',
  TransTypeName_CCA: 'Issue reasons',
  TransTypeName_SOI: 'Sales orders',
  TransTypeName_SOP: 'POS orders',
  TransTypeName_MOI: 'Transfer orders',
  TransTypeName_WOI: 'Work orders',
  ReferencesTitle: 'References',

  LoadingPurchaseOrders: 'Loading purchase orders...',

  PurchaseOrdersList: 'Purchase orders list',

  SearchPurchaseOrdersPlaceholder: 'Search purchase orders (number, supplier, amount, date...)',

  OrderDate: 'Order date',

  MatchesSearch: 'Matches search',

  PurchaseOrdersFilteredCount: '{{filtered}} of {{total}} purchase orders',
  SearchTermLabel: 'Search for',

  NoSearchResultsTitle: 'No search results',
  NoPurchaseOrdersMatchSearch: '"{{term}}" - No purchase orders match your search',
  ClearSearchAndShowAll: 'Clear search and show all',

  PurchaseOrdersFooterSummary: 'Showing {{filtered}} of {{total}} purchase orders',
  SearchedFor: 'Searched for:',

  LoadingReasons: 'Loading reasons...',

  Reasons_GenericTitle: 'reasons',
  Reasons_IssueTitle: 'issue reasons',
  Reasons_ReceiptTitle: 'receipt reasons',

  ReasonsListTitle: 'List of {{reasonType}}',
  ReasonName: 'Reason name',
  ReasonDescription: 'Description',

  ReasonsFooterSummary: 'Showing {{count}} of {{total}} reasons',

  LoadingSalesInvoices: 'Loading sales invoices...',

  SalesInvoicesListTitle: 'Sales orders list',

  LoadingSupplierReturns: 'Loading purchase returns...',

  SupplierReturnsListTitle: 'Purchase returns list',
  SupplierReturnsSearchPlaceholder: 'Search returns (number, supplier, amount, date...)',

  SupplierReturnsFilteredCount: '{{filtered}} of {{total}} returns',
  NoSupplierReturnsMatchSearch: '"{{term}}" - No returns match your search',
  SupplierReturnsFooterSummary: 'Showing {{filtered}} of {{total}} returns',

  LoadingTransferOrders: 'Loading transfer orders...',

  TransferOrdersListTitle: 'Transfer orders list',
  InboundInventory: 'Inbound inventory',
  TransferOrderDefaultName: 'Transfer order',

  TransferOrdersFooterSummary: 'Showing {{count}} of {{total}} transfer orders',

  LoadingWorkOrders: 'Loading work orders...',

  WorkOrdersListTitle: 'Maintenance work orders list',

  WorkOrdersFooterSummary: 'Showing {{count}} of {{total}} work orders'
};

export default translation;
